enum Permissions {
  FULL_ACCESS = 'rw',
  NONE = 'none',
  VIEW_ONLY = 'r',
}

export { Permissions };
